<section class="compare-page">
  <header class="compare-page__header">
    <div class="w-full flex flex-col">
      <h1 class="compare-page__title">Comparar productos</h1>
      <p class="compare-page__subtitle text-gray-400">
        Añade productos desde la tienda para compararlos lado a lado.
      </p>
    </div>
    <div class="w-full flex flex-row items-center justify-between">
      <a class="compare-page__back" routerLink="/tienda">
        <app-icon [icon]="backIcon" [size]="16" color="currentColor" />
        <span class="text-amber-600 hover:text-amber-700 transition-all hover:underline">Volver a la tienda</span>
      </a>
      @if (count() > 0) {
      <button type="button" class="compare-page__clear" aria-label="Vaciar comparador" (click)="onClear()">
        Limpiar comparador
      </button>
      }
    </div>
  </header>

  @if (loading() && items().length === 0) {
  <div class="compare-page__skeleton" aria-hidden="true">
    <div class="compare-page__skeleton-head"></div>
    <div class="compare-page__skeleton-body">
      @for (_ of [1,2,3,4,5,6]; track $index) {
      <div class="compare-page__skeleton-row"></div>
      }
    </div>
  </div>
  } @else if (error()) {
  <div class="compare-page__state compare-page__state--error" role="alert">
    <p>{{ error() }}</p>
    <app-button variant="secondary" size="md" (click)="onRetry()">
      <div class="compare-page__retry">
        <app-icon [icon]="retryIcon" [size]="16" color="currentColor" />
        <span>Reintentar</span>
      </div>
    </app-button>
  </div>
  } @else if (count() === 0) {
  <div class="compare-page__state compare-page__state--empty">
    <img class="compare-page__mascot" src="images/logo/empty_comparison.png" alt="Perrón confundido" width="120" height="120" loading="lazy" />
    <h2 class="compare-page__empty-title">
      Aún no has añadido productos para comparar
    </h2>
    <p class="compare-page__empty-text">
      Añade hasta {{ maxItems }} productos desde la tienda y
      compáralos atributo por atributo.
    </p>
    <app-button variant="primary" size="md">
      <a routerLink="/tienda" class="compare-page__empty-cta">
        Explorar tienda
      </a>
    </app-button>
  </div>
  } @else {
  @if (hasMissing()) {
  <div class="compare-page__banner compare-page__banner--warning" role="status">
    Algunos productos ya no existen y se han omitido.
  </div>
  }
  @if (hasUnavailable()) {
  <div class="compare-page__banner compare-page__banner--error" role="status">
    Algunos productos ya no están disponibles.
  </div>
  }

  <div class="compare-page__table-wrap">
    <table class="compare-table">
      <caption class="visually-hidden">Comparación de productos</caption>
      <thead>
        <tr>
          <th scope="col" class="compare-table__corner">
            <span class="visually-hidden">Atributo</span>
          </th>
          @for (item of items(); track trackItemId($index, item); let col = $index) {
          <th scope="col" class="compare-table__product-head">
            <button type="button" class="compare-table__remove" [attr.aria-label]="'Quitar ' + item.name + ' del comparador'" (click)="onRemove(item.id)">
              <app-icon [icon]="closeIcon" [size]="14" color="currentColor" />
            </button>

            <a class="compare-table__thumb-link" [routerLink]="productHref(item)">
              <img class="compare-table__thumb" [src]="item.imageUrl" [alt]="item.name" loading="lazy" />
            </a>

            @if (categories()[col]; as cat) {
            @if (cat.root) {
            <span class="compare-table__eyebrow">{{ cat.root }}</span>
            }
            <span class="compare-table__category">{{ cat.leaf }}</span>
            }

            <a class="compare-table__name" [routerLink]="productHref(item)">
              {{ item.name }}
            </a>

            @if (!isColOutOfStock()[col]) {
            <div class="compare-table__price-block">
              @if (formattedOriginalPrices()[col]) {
              <span class="compare-table__price-original">
                {{ formattedOriginalPrices()[col] }}
              </span>
              }
              <span class="compare-table__price">
                {{ formattedPrices()[col] }}
              </span>
              @if (discounts()[col] > 0) {
              <span class="compare-table__discount">
                -{{ discounts()[col] }}%
              </span>
              }
            </div>
            }

            @if (stockLabels()[col]; as sl) {
            <span class="compare-table__stock" [class.compare-table__stock--error]="sl.tone === 'error'" [class.compare-table__stock--warning]="sl.tone === 'warning'">
              {{ sl.label }}
            </span>
            }

            @if (variantLabels()[col]; as variant) {
            <app-variant-badge [variant]="item.variant">
              {{ variant }}
            </app-variant-badge>
            }
          </th>
          }
        </tr>
      </thead>
      <tbody>
        @for (row of rows(); track trackRow($index, row)) {
        <tr>
          <th scope="row" class="compare-table__row-label">{{ row.label }}</th>
          @for (value of row.values; track $index) {
          <td class="compare-table__cell" [class.compare-table__cell--diff]="row.diffs[$index]">
            {{ value ?? '—' }}
          </td>
          }
        </tr>
        }
      </tbody>
    </table>
  </div>
  }
</section>